import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogWelcomeOnboardingProfileComponent } from './dialog-welcome-onboarding-profile.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [DialogWelcomeOnboardingProfileComponent],
  imports: [
    CommonModule,
    MatDialogModule,
  ]
})
export class DialogWelcomeOnboardingProfile {}
